import {Directive, ElementRef, Input, OnInit, Renderer2} from "@angular/core";
import {IntAttrBindingPayload} from "./types";

@Directive({
  selector: '[intAttrBinding]'
})
export class IntAttrBindingDirective implements OnInit {
  @Input() intAttrBinding: IntAttrBindingPayload | Array<IntAttrBindingPayload> | null = null;
  constructor(
    private readonly renderer: Renderer2,
    private readonly elementRef: ElementRef
  ) {
  }

  ngOnInit() {

    if(this.intAttrBinding === null) {
      return;
    }

    const attrList = Array.isArray(this.intAttrBinding) ? this.intAttrBinding : [this.intAttrBinding];

    attrList.forEach(({attr, value}) => {
      if(!attr || (!value || typeof value === "number")) {
        return;
      }
      this.renderer.setAttribute(this.elementRef.nativeElement, attr, value);
    });
  }
}
